import React from 'react'
import '../Styles/Section2.css'
// import { useNavigate } from 'react-router-dom'

export default function Section2() {
  // const navigate = useNavigate();
  const sec2readmorenavigatehandler = ()=>{
    // navigate('./about');
    window.location.href = `/about`;
  }
  return (
    <div className='section2'>
      <div className="sec2container">
        <p className='sec2head'>WELCOME TO MAHARISHI DAYANAND COLLEGE OF EDUCATION</p>
        <div className="sec2box">
          <div className="sec2text">
            <div className="sec2text1">Maharishi dayanand college baduli was established by Mr. Matloob Ahmad in 2018 with positive attitude for those who want to achieve their goals.we are providing the better development in the education of the middle class students. MD college is situated in village baduli , kolki over bridge at 6th Milestone on the muzaffarnagar highway , saharanpur. The campus is easily accessible by public transport and is a mere 15 minute drive from gagalheri and just under an hour from saharanpur. The imposing 2-3 acres of green campus boasts of airy and well-lit roomy classrooms, finest laboratories and workshops, a modern computer center, a library endowed with relevant titles and the administrative block.</div>
            <div className="sec2text2">The Institute designed with fountains and has been aesthetically large landscaped lawns & gardens. With this entire infrastructure in place, the institute is strongly committed to provide quality education to its students. Incorporation of the latest in Information Technology ensures that students have access to library and computing facilities of the highest quality, with an array of networked computers, LCD Monitors, subject-specific software and access to the Internet.</div>
            <div className="sec2btn" onClick={sec2readmorenavigatehandler}>Read More</div>
          </div>
          <div className="sec2img"></div>
        </div>
      </div>
    </div>
  )
}

